const API_BASE = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:8000`;

function getCookie(name) {
  const cookiePrefix = `${name}=`;
  const cookie = document.cookie
    .split('; ')
    .find(row => row.startsWith(cookiePrefix));
  return cookie ? decodeURIComponent(cookie.slice(cookiePrefix.length)) : null;
}

export async function apiFetch(path, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  const isUnsafeMethod = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method);
  const headers = { ...(options.headers || {}) };

  if (isUnsafeMethod) {
    const csrfToken = getCookie('stackfab_csrf_token');
    if (csrfToken) {
      headers['X-CSRF-Token'] = csrfToken;
    }
    if (options.body && !headers['Content-Type']) {
      headers['Content-Type'] = 'application/json';
    }
  }

  const finalOptions = {
    credentials: 'include',
    ...options,
    headers
  };
  return fetch(`${API_BASE}${path}`, finalOptions);
}

export { API_BASE };
